import type {
	Components,
} from '@mui/material'

export const materialUITableTheme: {
	components: Components
} = {
	components: {
		MuiTable: {
			styleOverrides: {
				root: {

				},
			},
		},
		MuiTableCell: {
			styleOverrides: {
				root: {

				},
				sizeSmall: {
					padding: 'var(--base-spacing-2) !important',
				},
			},
		},
	},
}
